/*
 * Registry of pages migrated to the Element design system. An element page
 * is Bootstrap-free and GlobalStyle-free: PageElement stamps
 * data-element-page on <html>, which switches off the scoped Bootstrap build
 * (src/styles/generated/bootstrap-scoped.css guards every rule with
 * :where(html:not([data-element-page]))), and skips the styled-components
 * GlobalStyle. Pages are one system or the other — never mix Element and
 * Bootstrap UI on the same page (transitional exceptions lean on
 * src/styles/element-overrides.css).
 */
const ELEMENT_PAGES: string[] = ['/element-test', '/repair-and-cover']

const normalise = (pathname: string): string =>
  pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname

export const isElementPage = (pathname?: string): boolean =>
  pathname != null && ELEMENT_PAGES.includes(normalise(pathname))
